/**
 * MessagesPage — wrapper di backward compatibility
 * Il Diario di Bordo - Frontend
 *
 * Le route `/messaggi` e `/messaggi/:threadId` (e le copie su
 * `/organization/...`) sono state consolidate dentro il Centro
 * Comunicazioni in `pages/NotificationsPage.jsx` (tab "messaggi").
 *
 * Questo wrapper redirect mantiene la backward compat per:
 *  - notifiche push con actionUrl `/messaggi/<id>` già consegnate
 *  - link salvati / bookmark utente
 *  - test E2E o script che usano i vecchi path
 */

import { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'

export default function MessagesPage() {
  const { threadId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Determina il prefisso /organization se sotto la sezione Responsabile
    const isOrgRoute = location.pathname.startsWith('/organization')
    const base = isOrgRoute ? '/organization/notifiche' : '/notifiche'
    const target = threadId
      ? `${base}?tab=messaggi&thread=${encodeURIComponent(threadId)}`
      : `${base}?tab=messaggi`
    navigate(target, { replace: true })
  }, [threadId, location.pathname, navigate])

  return null
}
